<template>
    <footer class="footer py-30 py-lg-50">

        <v-container>

            <v-row class="flex-column-reverse flex-lg-row">
                <v-col cols="12" lg="7">
                    <p class="footer__tit page-text font-weight-bold line-height-1 mb-8 mb-lg-14">
                        한국전자정보통신산업진흥회 전자제조센터
                    </p>
                    <p class="footer__info mb-12 mb-lg-32">
                        주소 : 04366 서울특별시 용산구 청파로77 원효전자상가6동 3층 <br>
                        TEL : 070-5088-0218<span class="text-center d-none d-md-inline-block" style="width: 22px">|</span><br class="d-block d-md-none">
                        FAX : 070-7500-0095<span class="text-center d-none d-md-inline-block" style="width: 22px">|</span><br class="d-block d-md-none">
                        EMAIL : yes@gokea.org <br>
                        사업자등록번호 : 220-82-00143
                    </p>
                    <p class="footer__copy">
                        Copyright 2021. KOREA ELECTRONICS ASSOCIATION. All rights reserved.
                    </p>
                </v-col>
                <v-col cols="12" lg="5" class="d-lg-flex flex-lg-column align-lg-end mb-16 mb-lg-0">
                    <ul class="footer__link">
                        <li>
                            <router-link to="/privacy-policy">개인정보처리방침</router-link>
                        </li>
                        <!-- <span></span>
                        <li v-for="link in links" :key="link.text">
                            <a class="btn" :href="link.href" target="_blank">{{ link.text }}</a>
                        </li> -->
                    </ul>
                    <!-- <div class="mt-12 mt-lg-72">
                        <v-select large outlined hide-details placeholder="관련 사이트" append-icon="mdi-chevron-down" class="familysite mw-160px mw-lg-180px"
                        :items="sites" item-text="name" item-value="link">
                        </v-select>
                    </div> -->
                </v-col>
            </v-row>

        </v-container>

    </footer>
</template>

<script>
export default {
    data(){
        return {
            links:[
                { text: '회원사서비스현장', href: '#' },
                { text: '국내관련기관', href: '#' },
                { text: '사이트맵', href: '#' },
            ],
            sites : [
                {
                    name:"네이버",
                    link:"https://www.naver.com/"
                },
                {
                    name:"다음",
                    link:"https://www.daum.net/"
                },
            ]
        }
    },
    mounted(){
    },
    methods: {
    }
}
</script>

<style scoped>
</style>